/**
 * GOLF+ Homepage — Premade Bundle quick-add
 * Reads variant IDs from data-* attributes on each bundle card,
 * adds all items to cart via AJAX, then redirects to /cart.
 */
(function () {
  'use strict';

  document.querySelectorAll('[data-bundle-card]').forEach(function (card) {
    var btn = card.querySelector('[data-bundle-cta]');
    if (!btn) return;

    btn.addEventListener('click', function () {
      var v1 = card.dataset.v1;
      var v2 = card.dataset.v2;
      var v3 = card.dataset.v3;

      // Build items array — skip any empty variant IDs
      var items = [];
      [v1, v2, v3].forEach(function (id) {
        if (id && id !== '') {
          items.push({ id: parseInt(id, 10), quantity: 1 });
        }
      });

      if (items.length === 0) return;

      // Loading state
      var labelEl   = btn.querySelector('.gp-bundle-card__cta-label');
      var loadingEl = btn.querySelector('.gp-bundle-card__cta-loading');
      btn.disabled = true;
      if (labelEl)   labelEl.style.display   = 'none';
      if (loadingEl) loadingEl.style.display  = 'inline';
      btn.classList.add('gp-btn--loading');

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      })
      .then(function (res) {
        if (!res.ok) throw new Error('Cart add failed: ' + res.status);
        return res.json();
      })
      .then(function () {
        window.location.href = '/cart';
      })
      .catch(function (err) {
        console.error('GOLF+ bundle add error:', err);
        // Restore button
        btn.disabled = false;
        btn.classList.remove('gp-btn--loading');
        if (labelEl)   labelEl.style.display   = 'inline';
        if (loadingEl) loadingEl.style.display  = 'none';
        alert('Something went wrong. Please try again.');
      });
    });
  });

})();
